import { useDocumentTitle } from "@/hooks/use-document-title";
import { Text } from "@/components/podkit/typography/Text";
import type { FC } from "react";
import { AgentCommands } from "@/routes/settings/organization/agents/AgentCommands";
import { AgentPolicies } from "@/routes/settings/organization/agents/AgentPolicies";
import { AgentIntegrations } from "@/routes/settings/organization/agents/AgentIntegrations";

export const AgentsPage: FC = () => {
    useDocumentTitle("Agents");

    return (
        <div className="flex flex-col gap-6" data-testid="agents-page">
            <Text className="text-base text-content-secondary">
                Configure agent commands, policies, and integrations for your organization.
            </Text>

            <AgentPolicies />
            <AgentIntegrations />
            <AgentCommands />
        </div>
    );
};
